<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">
      <mat-icon class="material-symbols-outlined title-icon">drive_file_move</mat-icon>
      Mover Categorias Selecionadas
    </h2>
    <button mat-icon-button (click)="cancelar()" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <app-alert-card type="info">
      <p>
        Você está prestes a mover
        <strong
          >{{ data.idsCategorias.length }}
          {{ data.idsCategorias.length === 1 ? 'categoria' : 'categorias' }}</strong
        >:
      </p>
      <ul class="category-list">
        @for (nome of data.nomeCategorias; track nome) {
          <li>
            <code
              ><strong>{{ nome }}</strong></code
            >
          </li>
        }
      </ul>
      <p>
        Selecione a categoria de destino abaixo. Caso deixe o campo em branco, as categorias serão movidas
        para a <strong>raiz</strong> (sem categoria pai).
      </p>
    </app-alert-card>

    <app-alert-card type="warning">
      Categorias com subcategorias podem ser movidas, desde que o destino escolhido não ultrapasse
      <strong>3 níveis de hierarquia</strong> no total. Só são exibidas categorias de destino do
      <strong>mesmo tipo (Receita/Despesa)</strong> dos itens selecionados.
    </app-alert-card>

    @if (!isLoadingLookups) {
      <div class="form-section">
        <form [formGroup]="form">
          <app-select-pesquisavel
            label="Categoria Pai de Destino (Opcional)"
            [control]="$any(form).get('idCategoriaPai')"
            [idField]="'idCategoriaFinanceira'"
            [nameField]="'descricao'"
            [offlineList]="categoriasPaiValidas"
            [isOptional]="true"
            hint="Deixe vazio para mover para a raiz (sem categoria pai)">
          </app-select-pesquisavel>
        </form>
      </div>
    } @else {
      <div class="loading-container">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Carregando categorias...</span>
      </div>
    }
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button class="btn-secondary" (click)="cancelar()" [disabled]="isLoading">
      Cancelar
    </button>
    <button mat-flat-button class="btn-primary" (click)="mover()" [disabled]="isLoading || isLoadingLookups">
      @if (isLoading) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <span class="material-symbols-outlined">drive_file_move</span>
        Confirmar
      }
    </button>
  </div>
</div>
